 
 // all modules
export const allModulesDocs: Record<string, string> = {
  maiMol: "https://docs.moleculeai.com/docs/de-novo-generation/maimol/",
  ranker: "https://docs.moleculeai.com/docs/de-novo-generation/ranker/", // done
  autodock: "https://docs.moleculeai.com/docs/virtual-screening/docking/autodock",
  unidock: "https://docs.moleculeai.com/docs/virtual-screening/docking/unidock",
  screenie: "https://docs.moleculeai.com/docs/virtual-screening/screenie/", // done
  liftVisualizer: "https://docs.moleculeai.com/docs/virtual-screening/LIFT/LIFT%20Visualizer/", // done
  liftFilter: "https://docs.moleculeai.com/docs/virtual-screening/LIFT/LIFT%20Filter/", // done
  genFil: "https://docs.moleculeai.com/docs/virtual-screening/genfil/",
  admetPro: "https://docs.moleculeai.com/docs/admet-prediction/admet-pro/", // done
  leaderReinvent: "https://docs.moleculeai.com/docs/Lead%20Optimisation/leader/", // done
  bioSwap: "https://docs.moleculeai.com/docs/Lead%20Optimisation/bioswap/", // done
  substituteR: "https://docs.moleculeai.com/docs/Lead%20Optimisation/bioswap/",
  lodestar: "Lodestar", // done
  moleculeCopilot: "https://docs.moleculeai.com/docs/molecule-design/copilot/", // done
  molBench: "https://docs.moleculeai.com/docs/molecule-design/molbench/", //done
  drViz: "Dr Viz",
  clusterPro : "clusterPro"
};